module.exports = __webpack_public_path__ + "static/media/check_active.daec9f8d.svg";